'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof Object.getOwnPropertyDescriptors === 'function' ? Object.getOwnPropertyDescriptors : implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/object.getownpropertydescriptors/polyfill.js
// module id = 373
// module chunks = 35783957827783 172322841747965